import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ListOkrs } from "./Index";
import { AddNewOkr } from "./Index";
import { Grid, IconButton } from "@mui/material";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useNavigate } from "react-router";
import InfiniteScroll from "react-infinite-scroller";
import dummyData from './ContentLoaderData.json';
import { StencilList } from "react-placemoulder";
import { FilterOKR } from "./Index";
import { useSearchParams } from "react-router-dom";
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { loadStatus } from "../../../redux/actions/lookups.action";
import Button from "@mui/material/Button";
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import moment from "moment";
import { format, parseISO } from 'date-fns'
import { useMemo } from 'react';



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



let showMyOkr = false;


const OKRs = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  console.log(searchParams);

  console.log(searchParams.get("statusId") !== "null" ? searchParams.get("statusId") : null)

  let p_name = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  console.log(params.get('isArchived'))
  const [statusList, setStatusList] = React.useState([]);

  let from;
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const [isAssignKR, setIsAssignKR] = React.useState(false);
  const [selectedOkrId, setSelectedOkrId] = React.useState(null);
  const [summary, setSummary] = React.useState(null);
  const [totalRecords, setTotalRecords] = React.useState("");
  const [totalPages, setTotalPages] = React.useState("");
  const [page, setPage] = React.useState(1);

  console.log(searchParams.get('dueDate'))
  const [dueDate, setDueDate] = React.useState(searchParams.get('dueDate') !== "null" ? searchParams.get('dueDate') : null);
  const [orderBy, setOrderBy] = React.useState(searchParams.get("orderBy") ? searchParams.get("orderBy") : "DueDate");
  const [orderByDirection, setOrderByDirection] = React.useState(searchParams.get("orderByDirection") ? searchParams.get("orderByDirection") : "ASC");
  const [statusId, setStatusId] = React.useState(params.get('statusId') !== "null" ? params.get('statusId') : null);
  const [departmentId, setDepartmentId] = React.useState(searchParams.get("departmentId") !== "null" ? searchParams.get('departmentId') : null);
  const [teamId, setTeamId] = React.useState(searchParams.get("teamId") !== "null" ? searchParams.get("teamId") : null);
  const [assignedUserId, setAssignedUserId] = React.useState(searchParams.get("assignedUserId") !== "null" ? searchParams.get("assignedUserId") : null);
  let [year, setYear] = React.useState(searchParams.get("year") !== "null" ? searchParams.get("year") : null);
  let [dateFilter, setDateFilter] = React.useState(searchParams.get("dateFilter") !== "null" ? searchParams.get("dateFilter") : null);
  let [title, setTitle] = React.useState(searchParams.get('title') !== "null" ? searchParams.get('title') : null);
  let [isArchived, setIsArchived] = React.useState(searchParams.get('isArchived') === 'true' ? true : false);
  let [isPastDueDate, setIsPastDueDate] = React.useState(searchParams.get("passedDueDate") !== "true" ? false : true);
  // const [showMyOkr, setShowMyOkr] = React.useState(false);
  const [list, setlist] = React.useState(dummyData);
  const [isLoading, setIsLoading] = React.useState(false);
  const [request, setRequest] = React.useState();
  const [scrolling, setScrolling] = React.useState(false);
  const [participantId, setParticipantId] = React.useState(searchParams.get("participantId") !== "null" ? searchParams.get("participantId") : null);
  const [keyword, setKeyword] = React.useState(searchParams.get("title") !== "null" ? searchParams.get("title") : null);
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  const [objectiveTitle, setObjectiveTitle] = React.useState("");

  const [includeKeyResult, setIncludeKeuResult] = React.useState(false);


  function GMT_UTC(now) {

    if (now !== "null" && now !== null) {
      let date = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
      console.log(date);
      return date;
    }

  }
  function convert(str) {

    console.log(searchParams.get('dueDate'))
    if (str !== "null" && str !== null) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      console.log([date.getFullYear(), mnth, day].join("-"));
      setDueDate(parseISO([date.getFullYear(), mnth, day].join("-")));
      return [date.getFullYear(), mnth, day].join("-");
    }

  }


  const navigate = useNavigate();
  const dispatch = useDispatch();





  const toggleOkrPopup = (param, obj) => {

    if (param !== undefined && param !== "1") {
      setIsPopupOpen(false);
    } else if (param === undefined) {
      setIsAssignKR(false);
      setIsPopupOpen(true);
    } else if (param === "1") {
      setSelectedOkrId(obj.okrId);
      setObjectiveTitle(obj.okrTitle)
      setIsPopupOpen(true);
      setIsAssignKR(true);
    }
  };




  const filterOkr = (req) => {

    console.log(req);
    setSearchParams(req);
    axiosFetch({
      method: "post",
      url: "/okrs",
      requestConfig: req
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200) {
          if (page > 1) {
            var okrs = [...list.okrs, ...res.data.okrs];
            setlist({ okrs: okrs });
            setScrolling(false);
          }
          else {
            setlist(res.data);
            setScrolling(false);
          }
          setSummary(res.data.summary);
          setTotalRecords(res.data.pagination.totalRecords);
          setTotalPages(res.data.pagination.totalPages);
        }
        if (res.status === 400) {

          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
      .catch(err => {
        console.error(err);
      })
  }



  const loadAll_OKRs = () => {

    var req;
    if (page === 1) {
      setIsLoading(true);
    }
    if (from !== undefined) {


      req = {
        "page": page,
        "resultsPerPage": 10,
        "year": year,
        "dateFilter": dateFilter,
        "title": title,
        "statusId": statusId,
        "orderBy": orderBy,
        "orderByDirection": orderByDirection,
        "assignedUserId": assignedUserId,
        "dueDate": dueDate,
        "departmentId": departmentId,
        "teamId": teamId,
        "showMyOkr": false,
        "isArchived": isArchived,
        "participantId": participantId,
        "passedDueDate": isPastDueDate,
        "includeKR": includeKeyResult
      }

    }
    else {

      req = {
        "page": page,
        "resultsPerPage": 10,
        "year": year,
        "dateFilter": dateFilter,
        "title": title,
        "statusId": statusId,
        "orderBy": orderBy,
        "orderByDirection": orderByDirection,
        "assignedUserId": assignedUserId,
        "dueDate": dueDate,
        "departmentId": departmentId,
        "teamId": teamId,
        "showMyOkr": false,
        "isArchived": isArchived,
        "participantId": participantId,
        "passedDueDate": isPastDueDate,
        "includeKR": includeKeyResult
      }

    }

    console.log(req);

    axiosFetch({
      method: "post",
      url: "/okrs",
      requestConfig: req
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200) {

          // setRequest({
          //   "page": page,
          //   "resultsPerPage": 10,
          //   "year": year,
          //   "dateFilter": dateFilter,
          //   "title": searchParams.get("title") !== "null" ? searchParams.get("title") : null,
          //   "statusId": statusId,
          //   "orderBy": orderBy,
          //   "orderByDirection": orderByDirection,
          //   "assignedUserId": assignedUserId,
          //   "dueDate": dueDate,
          //   "departmentId": departmentId,
          //   "showMyOkr": false,
          //   "isArchived": isArchived,
          //   "participantId": participantId,
          //   "passedDueDate": isPastDueDate,
          //   "includeKR": includeKeyResult
          // });



          if (page > 1) {
            var okrs = [...list.okrs, ...res.data.okrs];
            setlist({ okrs: okrs });
            setScrolling(false);
          }
          else {
            setlist(res.data);
            setScrolling(false);
          }
          setSummary(res.data.summary);
          setTotalRecords(res.data.pagination.totalRecords);
          setTotalPages(res.data.pagination.totalPages);
        }
        if (res.status === 400) {

          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
      .catch(err => {
        console.error(err);
      })
  }

  const handleInfiniteOnLoad = () => {

    // to avoid additional api hit
    if (page + 1 <= totalPages) {
      setPage(page + 1);
    }
    setScrolling(true);
  };




  const handlePageChange = (val) => {
    setPage(val);
  }
  const handleChangeYear = (value) => {
    setYear(value);
  }
  const handleIsArchive = (val) => {
    setIsArchived(val);
  }

  const handleIsPastDueDate = (val) => {
    setIsPastDueDate(val);
  }

  const handleChangeDateFilter = (value) => {
    setDateFilter(value);
  }

  const handleChangeTitle = (val) => {
    val === null ? setTitle(null) : setTitle(val);
  }

  const handleChangeStatusId = (val) => {
    setStatusId(val);
  }

  const handleChangeDepartment = (val) => {

    setDepartmentId(val);
  }

  const handleChangeTeam = (val) => {

    setTeamId(val);
  }

  const handleChangeParticpantId = (val) => {
    let participantsId;
    if (val !== null && val.length !== 0) {
      participantsId = val.map(arr => arr.value).toString();
      setParticipantId(participantsId);
    }
    else if (val === null || val.length === 0) {
      setParticipantId(null);
    }
  }
  const handleChangeAssignedUserId = (val) => {
    let ownersId;
    if (val !== null && val.length !== 0) {
      ownersId = val.map(arr => arr.value).toString();
      setAssignedUserId(ownersId);
    }
    else if (val === null || val.length === 0) {
      setAssignedUserId(null);
    }
  }



  const handleChangeDueDate = (val) => {
    setDueDate(val);
  }

  const toggleIncludeKR = (val) => {
    setIncludeKeuResult(val);
  }

  const handleChangeSortBy = (val, req) => {
    setPage(1);
    setOrderBy(val);
    var obj = {
      "page": page,
      "resultsPerPage": 10,
      "year": year,
      "dateFilter": dateFilter,
      "title": title,
      "statusId": statusId,
      "orderBy": req.orderBy,
      "orderByDirection": req.orderByDirection,
      "assignedUserId": assignedUserId,
      "dueDate": dueDate !== null && dueDate !== "null" ? new Date(dueDate).toISOString() : null,
      "departmentId": departmentId,
      "showMyOkr": showMyOkr,
      "isArchived": isArchived,
      "participantId": participantId,
      "passedDueDate": isPastDueDate
    }
    setSearchParams(obj);




    // loadAll_OKRs();
  }

  const handleChangeSortDirection = (val) => {
    setOrderByDirection(val);
  }

  const clearList = () => {
    setSearchParams("");
    setKeyword("");
    setTitle("");

    window.location.reload();

    if (p_name === '/myokrs') {
      showMyOkr = true;
    }
    else if (p_name === '/listokrs') {
      showMyOkr = false;
    }

    if (page === 1) {
      loadAll_OKRs();
    }
    else {
      setPage(1);
    }

  }
  React.useEffect(() => {


    // GMT_UTC(searchParams.get('dueDate'))
    loadAll_OKRs();
    loadStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderByDirection, orderBy, page])




  const loadStatus = () => {
    axiosFetch({
      method: "get",
      url: "/Lookup/okrstatus"
    })
      .then((res) => {
        setStatusList(res.data);
      })
      .catch(err => {
        console.error(err);
      })
  }

  const handleChangeStatus = (obj) => {
    if (obj !== null) {
      setSelectedStatus(obj);
      setStatusId(obj.value);
    }
    else if (obj === null) {
      setSelectedStatus(null);
      setStatusId(null);
    }
  }

  const handleChangeKeyword = (e) => {
    setKeyword(e.target.value);
    setTitle(e.target.value);
  }

  const generateQryStr = () => {

    if (page === 1) {
      var req = {
        "page": page,
        "resultsPerPage": 10,
        "year": year,
        "dateFilter": dateFilter,
        "title": title,
        "statusId": statusId,
        "orderBy": orderBy,
        "orderByDirection": orderByDirection,
        "assignedUserId": assignedUserId,
        "dueDate": dueDate !== null && dueDate !== "null" ? new Date(dueDate).toISOString() : null,
        "departmentId": departmentId,
        "teamId": teamId,
        "showMyOkr": showMyOkr,
        "isArchived": isArchived,
        "participantId": participantId,
        "passedDueDate": isPastDueDate,
        "includeKR": includeKeyResult
      }
    }
    else {
      setPage(1);
      var req = {
        "page": 1,
        "resultsPerPage": 10,
        "year": year,
        "dateFilter": dateFilter,
        "title": title,
        "statusId": statusId,
        "orderBy": orderBy,
        "orderByDirection": orderByDirection,
        "assignedUserId": assignedUserId,
        "dueDate": dueDate !== null && dueDate !== "null" ? new Date(dueDate).toISOString() : null,
        "departmentId": departmentId,
        "teamId": teamId,
        "showMyOkr": showMyOkr,
        "isArchived": isArchived,
        "participantId": participantId,
        "passedDueDate": isPastDueDate,
        "includeKR": includeKeyResult
      }
    }
    setRequest(req);
    setSearchParams(req);
    loadAll_OKRs();
  }

  const handleSearch = useMemo(() => {

    generateQryStr();
  }, [year, dateFilter, title, statusId, assignedUserId, dueDate, departmentId, isArchived, participantId, isPastDueDate, includeKeyResult, teamId]);

  return (
    <>
      {isPopupOpen ? (
        <AddNewOkr
          open={true}
          toggleOkrPopup={toggleOkrPopup}
          isAssignKR={isAssignKR}
          selectedOkrId={selectedOkrId}
          objectiveTitle={objectiveTitle}
          loadAll_OKRs={loadAll_OKRs}
          handlePageChange={handlePageChange}
          callFrom={0}
          pageNo={page}
        />
      ) : ("")}
      <Box>
        <Box className="tabs-main">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {p_name === '/myokrs' ? <h1 className="main-heading">My OKRs</h1> : <h1 className="main-heading">All OKRs </h1>}
            </Grid>
            <Grid item xs={6}>
              <IconButton
                className="addokr-btn theme-btn"
                variant="contained"
                onClick={() => toggleOkrPopup()}>

                Add OKR
              </IconButton>
            </Grid>
          </Grid>
        </Box>

        <FilterOKR
          // {...list}
          filterOkr={filterOkr}
          orderBy={orderBy}
          orderByDirection={orderByDirection}
          request={request}
          pageNo={page}
          from={p_name === '/myokrs' ? 0 : 1}
          loadAll_OKRs={loadAll_OKRs}
          handleChangeDepartment={handleChangeDepartment}
          handleChangeTeam={handleChangeTeam}
          handlePageChange={handlePageChange}
          handleChangeYear={handleChangeYear}
          handleChangeParticpantId={handleChangeParticpantId}
          handleChangeAssignedUserId={handleChangeAssignedUserId}
          handleChangeStatusId={handleChangeStatusId}
          handleChangeTitle={handleChangeTitle}
          handleChangeDateFilter={handleChangeDateFilter}
          handleChangeDueDate={handleChangeDueDate}
          handleIsArchive={handleIsArchive}
          totalRecords={totalRecords}
          clearList={clearList}
          handleIsPastDueDate={handleIsPastDueDate}
          handleSearch={handleSearch}
          generateQryStr={generateQryStr}
          toggleIncludeKR={toggleIncludeKR}
        />
        {isLoading ?
          (
            <StencilList
              length={1}
              Component={ListOkrs}
              data={dummyData}
            />) : (
            <InfiniteScroll
              datalength={list.okrs.length}
              initialLoad={false}
              loadMore={scrolling === false ? handleInfiniteOnLoad : ""}
              hasMore={page <= totalPages}
              threshold={500}
            >
              <ListOkrs
                from={p_name === '/myokrs' ? 0 : 1}
                toggleOkrPopup={toggleOkrPopup}
                {...list}
                request={request}
                loadAll_OKRs={loadAll_OKRs}
                handleChangeSortBy={handleChangeSortBy}
                handleChangeSortDirection={handleChangeSortDirection}
                handlePageChange={handlePageChange}
                totalRecords={totalRecords}
                summary={summary}
                pageNo={page}
                clearList={clearList}
                orderBy={orderBy}
                orderByDirection={orderByDirection}
              />
            </InfiniteScroll>)}

        {/* {scrolling ? (
          <StencilList length={1} Component={ListOkrs} data={dummyData} />
        ) : ""} */}
      </Box>
    </>
  );
};

export default OKRs;
